/* Polarsmile · bewegende iconen: zet .is-live op .ss-ai zodra het icoon in beeld komt (de beweging loopt dan
   2 keer, zie ss-icons.css) en .is-in op [data-ss-fill] zodra het één keer in beeld komt (balken die vollopen).
   Draait één keer per pagina, ook als het script door meerdere secties wordt ingeladen (window.ssAiInit),
   en scant opnieuw na een sectie-herlaad in de theme-editor. */
(function () {
  if (window.ssAiInit) return;
  window.ssAiInit = true;
  var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;
  if (!('IntersectionObserver' in window)) {
    document.querySelectorAll('[data-ss-fill]').forEach(function (el) { el.classList.add('is-in'); });
    return;
  }
  // Sinds 30-09-2026: .is-live blijft staan zodra het icoon in beeld komt. De animaties in ss-icons.css
  // lopen 2 keer en stoppen dan; bij opnieuw in beeld scrollen starten ze niet opnieuw.
  var live = reduce ? null : new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-live');
      live.unobserve(e.target);
    });
  }, { threshold: 0.25 });
  var fill = new IntersectionObserver(function (entries) {
    entries.forEach(function (e) {
      if (!e.isIntersecting) return;
      e.target.classList.add('is-in');
      fill.unobserve(e.target);
    });
  }, { threshold: 0.35 });
  function scan(root) {
    root = root || document;
    if (live) root.querySelectorAll('.ss-ai:not([data-ai])').forEach(function (el) { el.setAttribute('data-ai', ''); live.observe(el); });
    root.querySelectorAll('[data-ss-fill]:not(.is-in)').forEach(function (el) { fill.observe(el); });
  }
  scan();
  document.addEventListener('shopify:section:load', function (e) { scan(e.target); });
})();
